import * as React from 'react'

import Svg, { G, Mask, Path } from 'react-native-svg'

import { IconProps } from '..'

const Notification = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <Path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </Mask>
    <G mask="url(#a)">
      <Path
        fill="#6826A0"
        d="M2 10c0-1.467.296-2.854.888-4.162A9.722 9.722 0 0 1 5.425 2.45l1.425 1.4c-.9.783-1.6 1.704-2.1 2.762A7.831 7.831 0 0 0 4 10H2Zm18 0c0-1.2-.25-2.33-.75-3.388a8.369 8.369 0 0 0-2.1-2.762l1.425-1.4c1.1.95 1.946 2.08 2.538 3.388A9.985 9.985 0 0 1 22 10h-2ZM4 19v-2h2v-7c0-1.383.417-2.612 1.25-3.688.833-1.075 1.917-1.779 3.25-2.112v-.7c0-.417.146-.77.438-1.063A1.447 1.447 0 0 1 12 2c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062v.7c1.333.333 2.417 1.037 3.25 2.112C17.583 7.388 18 8.617 18 10v7h2v2H4Zm8 3c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 10 20h4c0 .55-.196 1.02-.588 1.413A1.926 1.926 0 0 1 12 22Zm-4-5h8v-7c0-1.1-.392-2.042-1.175-2.825C14.042 6.392 13.1 6 12 6s-2.042.392-2.825 1.175C8.392 7.958 8 8.9 8 10v7Z"
      />
    </G>
  </Svg>
)
export default Notification
